import React, { useState } from 'react';

const TableFilter = ({ onFilter, placeholder = "Search..." }) => {
  const [filterText, setFilterText] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setFilterText(value);
    onFilter(value);
  };

  return (
    <div className="mb-3">
      <div className="input-group">
        <span className="input-group-text">
          <i className="fas fa-search"></i>
        </span>
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={filterText}
          onChange={handleChange}
        />
        {filterText && (
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => {
              setFilterText('');
              onFilter('');
            }}
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default TableFilter;
